import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_COPY_CAMPAIGN_SERVER } from '@/app/module/campaigns/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useCopyCampaign = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [copyCampaign, res] = esApi.endpoints.copyCampaign.useMutation()

  const copy = useCallback(
    async (campaignId: number) => {
      try {
        const result = await copyCampaign({
          orgId: String(orgId),
          campaignId: String(campaignId),
          body: {},
        }).unwrap()

        dispatch(
          createNotification({
            'copy-campaign': {
              type: 'success',
              message: 'Your campaign was duplicated successfully.',
            },
          }),
        )

        return { id: result.engagementId }
      } catch (error) {
        dispatch(
          createNotification({
            'copy-campaign': {
              type: 'error',
              message: getErrorMessage(error, ERROR_COPY_CAMPAIGN_SERVER),
            },
          }),
        )
        return undefined
      }
    },
    [copyCampaign, dispatch, orgId],
  )

  return [copy, res] as const
}
